/**
 * DevTools console logs for JSON import/export flows.
 */

const PREFIX = "[Pubconsole config JSON import/export]";

export function summarizePayload(payload) {
    if (!payload || typeof payload !== "object") {
        return { topLevelKeys: 0, approxJsonChars: 0 };
    }
    try {
        const json = JSON.stringify(payload);
        return {
            topLevelKeys: Object.keys(payload).length,
            approxJsonChars: json.length,
        };
    } catch {
        return { topLevelKeys: Object.keys(payload).length, approxJsonChars: 0 };
    }
}

export function logExport(flow, detail) {
    console.info(PREFIX, "EXPORT", flow, detail);
}

export function logImport(flow, phase, detail, err) {
    if (err) {
        console.error(PREFIX, "IMPORT", flow, phase, detail, err);
    } else {
        console.info(PREFIX, "IMPORT", flow, phase, detail);
    }
}

export function logSaveClient(flow, ok, detail, err) {
    if (ok) {
        console.info(PREFIX, "SAVE_OK → API", flow, detail);
    } else {
        console.error(PREFIX, "SAVE_FAILED", flow, detail, err);
    }
}
